/** @flow */
import * as React from 'react';

export interface Props {
  id: string;
  interval: number;
  callback: () => Promise<void>;
}

export interface State {
  timer: IntervalID;
}

export default class TimerComponent extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    props.callback();
    const timer = setInterval(props.callback, props.interval);

    this.state = { timer };
  }

  componentWillUnmount() {
    clearInterval(this.state.timer);
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/common/components/TimerComponent.js